import { PathToStrings } from "./types/sharedTypes"

export const TABLET_LOW_BATTERY_THRESHOLD = 20
export const TABLET_STATUS_REFRESH_TIME = 60 // seconds
const ONE_MINUTE_MS = 60_000
/** Native visitor tablet: periodic e-paper BLE scan + EPAPER_BADGE_STATUS reporting. */
export const EPAPER_BADGE_STATUS_INTERVAL_MS = 10 * ONE_MINUTE_MS

/** Start page: skip prefetch BLE scan when the previous scan ended more recently than this. */
export const EPAPER_START_PAGE_PREFETCH_MIN_INTERVAL_MS = 2 * ONE_MINUTE_MS

/** Bluetooth SIG company ID for e-paper badge advertisements (native scan + JS filter). */
export const EPAPER_BADGE_BLE_COMPANY_ID = "0x5258" as const

export const DEFAULT_NS = "translation"
export const WHITELABEL_NS = "translationWhitelabel"

export const IS_WHITE_LABEL =
  import.meta.env.VITE_APP_MOBILE_MODE === "WHITELABEL"

export const FETCH_WITH_NO_LIMIT = 10000

export const DEFAULT_POLLING_INTERVAL_MS = 60000

export const COUNTRIES: Record<string, string> = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, The Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote d'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, The Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
}

export const COUNTRY_OPTIONS = Object.entries(COUNTRIES).map(
  ([key, value]) => ({
    value: key,
    label: value,
  }),
)

/* Languages for devices */
export const LANGUAGES: Record<string, string> = {
  ar: "Arabic",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  en: "English (American)",
  // Backend maps en-US to en-GB as a hack
  "en-US": "English (British)",
  fi: "Finnish",
  fr: "French",
  de: "German",
  is: "Icelandic",
  it: "Italian",
  lv: "Latvian",
  lt: "Lithuanian",
  nb: "Norwegian Bokmål",
  pl: "Polish",
  pt: "Portuguese",
  ru: "Russian",
  "zh-Hans": "Simplified Chinese",
  sk: "Slovak",
  sl: "Slovenian",
  es: "Spanish",
  sv: "Swedish",
}

export const LANGUAGE_OPTIONS = Object.entries(LANGUAGES).map(
  ([key, value]) => ({
    value: key,
    label: value,
  }),
)

export const TIME_FORMATS = {
  "1": { label: "24-hour", format: "HH:mm" },
  "2": { label: "AM/PM", format: "hh:mm A" },
} as const

export const TIME_FORMAT_OPTIONS = Object.entries(TIME_FORMATS).map(
  ([key, value]) => ({
    value: key,
    label: value.label,
  }),
)

export const PRIMARY_COLOR = "#4205DD"

export const HOME_PATHS = {
  buildingSelect: "/building-selection",
  desktop: "/manage",
  mobile: "/home/reservations",
  visitor: "/visitors",
  scanQrCode: "/scan-qr-code",
  settings: "/settings",
  analytics: "/analytics",
  screening: {
    root: "/screening/employee/:building_id",
    completed: "/screening/employee/:building_id/completed",
    failed: "/screening/employee/:building_id/failed",
  },
  mobile_redirect:
    "/(loading|auth/login|auth/start|home|book|floor|presence|profile|notifications)",
}

/**
 * Defines the constant labels used in the application
 * LABELS and WHITE_LABEL_LABELS are linked by Labels type which
 * means that they should have the same structure.
 */
export const LABELS = {
  links: {
    termsOfUseURL: "https://getjoan.com/terms-of-use/",
    privacyPolicyURL: "https://getjoan.com/privacy-policy/",
    supportEmail: "support@getjoan.com",
    knowledgeURL: "https://support.getjoan.com/knowledge",
    pricingURL: "https://getjoan.com/pricing/",
    howToAddDevicesURL:
      "https://support.getjoan.com/knowledge/how-to-add-your-devices",
    howToConfigureDevicesURL:
      "https://support.getjoan.com/knowledge/how-to-configure-your-devices",
    howToInviteVisitorsFromCalendarURL:
      "https://support.getjoan.com/knowledge/how-to-invite-visitors-from-your-calendar",
    howToInviteDeskBookingAppUsers:
      "https://support.getjoan.com/knowledge/inviting-joan-desk-booking-app-users",
    appPermsURL: "https://support.getjoan.com/knowledge/how-to-add-devices",
    howToConfigureDesksAndAssetsURL:
      "https://support.getjoan.com/knowledge/how-to-configure-the-desk-booking-app",
    deskBookingInstructionsURL:
      "https://support.getjoan.com/knowledge/instructions-for-joan-desk-booking-app-users",
    supportFormURL:
      "https://share-eu1.hsforms.com/1W8drJxQeREyRfQ3GU3yQFQf39l1",
    requestQRCodeStickersFormURL:
      "https://share-eu1.hsforms.com/1ViJzAi2cS0im5FCsRzqtWQf39l1",
    salesEmail: "sales@getjoan.com",
    salesFormUrl:
      "https://getjoan.com/about/?multiform=contact-sales#contact-us",
    cancelSubscriptionFormURL:
      "https://visionect.typeform.com/to/PG8NtK9X#email=xxxxx&solutions=xxxxx",
    tabletURL: "https://tablet.getjoan.com",
    displayURL: "https://display.getjoan.com",
    floorPlanColorsInfoURL:
      "https://support.getjoan.com/knowledge/desk-status-colors-in-floor-plan-view-a-quick-guide",
    integrationsInfoURL:
      "https://support.getjoan.com/knowledge/joan-integrations",
    aiInClaudeURL: "https://support.getjoan.com/ai-in-claude/joan-ai-in-claude",
  },
  deviceTypes: {
    joan_6: "Joan 6",
    joan_6_pro: "Joan 6 Pro",
    joan_6_re: "Joan 6 RE",
    joan_9: "Joan 9",
    joan_13: "Joan 13",
    joan_13_pro: "Joan 13 Pro",
    joan_32: "Joan 32",
    joan_on_display: "Joan on Display",
    joan_on_tablets: "Joan on Tablets",
  },
}

export const WHITE_LABEL_LABELS: Labels = {
  links: {
    termsOfUseURL: "https://getjoan.com/re/terms-of-use/",
    privacyPolicyURL: "https://getjoan.com/re/privacy-policy/",
    supportEmail: "pimsil.helpdesk@in.panasonic.com",
    pricingURL: "https://getjoan.com/re/pricing/",
    knowledgeURL: "https://support.roombookingsys.com/hc/en-us",
    howToAddDevicesURL:
      "https://support.roombookingsys.com/hc/en-us/articles/11528419207580-How-to-add-your-devices",
    howToConfigureDevicesURL:
      "https://support.roombookingsys.com/hc/en-us/articles/11528347842076-How-to-configure-your-devices-for-easy-check-in-",
    howToInviteVisitorsFromCalendarURL:
      "https://support.roombookingsys.com/hc/en-us/articles/11528684283164-How-to-invite-Visitors-from-your-Calendar-",
    // TODO: will need to find out/get links for whitelabel
    howToInviteDeskBookingAppUsers:
      "https://support.getjoan.com/knowledge/inviting-joan-desk-booking-app-users",
    appPermsURL:
      "https://support.roombookingsys.com/hc/en-us/articles/11528755497372-Room-booking-Office-permissions-in-the-application",
    howToConfigureDesksAndAssetsURL:
      "https://support.roombookingsys.com/hc/en-us/articles/11529264949660-How-to-configure-the-Room-booking-Office-system",
    // TODO: will need to find out/get links for whitelabel
    deskBookingInstructionsURL:
      "https://support.getjoan.com/knowledge/instructions-for-joan-desk-booking-app-users",
    supportFormURL:
      "https://share-eu1.hsforms.com/1W8drJxQeREyRfQ3GU3yQFQf39l1",
    requestQRCodeStickersFormURL:
      "https://share-eu1.hsforms.com/1ViJzAi2cS0im5FCsRzqtWQf39l1",
    // TODO: will need to find out/get links for whitelabel
    salesEmail: "pimsil.helpdesk@in.panasonic.com",
    // TODO: will need to find out/get links for whitelabel
    salesFormUrl: "mailto:pimsil.helpdesk@in.panasonic.com",
    // Same as for LABELS
    cancelSubscriptionFormURL:
      "https://visionect.typeform.com/to/PG8NtK9X#email=xxxxx&solutions=xxxxx",
    tabletURL: "https://tablet.roombookplus.in.panasonic.com",
    displayURL: "https://display.roombookplus.in.panasonic.com",
    floorPlanColorsInfoURL:
      "https://support.getjoan.com/knowledge/desk-status-colors-in-floor-plan-view-a-quick-guide",
    // TODO: will need to find out/get links for whitelabel
    integrationsInfoURL:
      "https://support.getjoan.com/knowledge/joan-integrations",
    // TODO: will need to find out/get links for whitelabel
    aiInClaudeURL: "https://support.getjoan.com/ai-in-claude/joan-ai-in-claude",
  },
  deviceTypes: {
    joan_6: "6 ″ Device",
    joan_6_pro: "6 ″ Pro Device",
    joan_6_re: "6 ″ RE Device",
    joan_9: "9 ″ Device",
    joan_13: "13 ″ Device",
    joan_13_pro: "13 ″ Pro Device",
    joan_32: "32 ″ Device",
    joan_on_display: "Room Booking on Display",
    joan_on_tablets: "Room Booking on Tablets",
  },
}

export type LabelPaths = PathToStrings<typeof LABELS>
type Labels = typeof LABELS

export const POSTHOG_TEAM_ID = "team_id"
export const POSTHOG_TEAM_DOMAIN = "team_domain"

export const FEATURE_FLAGS = {
  BOOKING_REMINDER: "Booking reminder",
  OFFICE_MANAGER_ANALYTICS_ACCESS: "Office manager analytics access.isEnabled",
  OFFICE_MANAGER_ROOM_VISIBILITY: "Office manager room visibility",
  EDIT_RECURRING_RESERVATIONS: "Edit recurring reservations",
  NEW_BUSINESS_MODEL_BETA: "subscriptions.v3.beta.isEnabled",
  LEGACY_NOTIFICATION_SETTINGS: "legacyNotificationSettings.isEnabled",
  ZOOM_INTEGRATION: "zoom.isEnabled",
  CUSTOM_CONTENT_ON_AC_DEVICES: "customContentOnACDevices.isEnabled",
  CALENDARS_ONLINE_MEETING_IS_DISABLED: "calendars.onlineMeeting.isDisabled",
  WHITELABEL_ENABLED: "enterprise.whitelabel.isEnabled",
  NEW_MOBILE_APP: "newMobileApp.isEnabled",
  VISITOR_MANAGEMENT_SHOW_ALL_LOCATION_HOSTS:
    "Visitor Management - Show all location hosts",
  VISITS_WITH_ROOM_AND_ASSETS_RESERVATIONS:
    "Visits with Room and Assets Reservations",
  USER_ROLES_IS_ENABLED: "userRoles.isEnabled",
  INTEGRATIONS_APPS: "integrations.apps.isEnabled",
  EMPLOYEE_BADGE: "employeeBadge.isEnabled",
  EMPLOYEE_BADGE_CUSTOM_IMAGE: "employeeBadge.customImage.isEnabled",
  REMOTE_DEBUGGING: "remoteDebugging.isEnabled",
} as const

export const FETCH_FOR_COUNT = { limit: 1 }

export const FETCH_UNREAD = {
  valid: true,
  seen: false,
}

export const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  BAD_GATEWAY: 502,
} as const

export const USER_DATE_FORMAT = "ll"
export const SHORT_USER_DATE_FORMAT = "l"
export const USER_DATE_WITH_TIME_FORMAT = "lll"

export const TYPEFORM_CANCELLATION_FORM_ID = import.meta.env
  .VITE_APP_TYPEFORM_CANCELLATION_FORM_ID

export const TYPEFORM_DELETION_FORM_ID = import.meta.env
  .VITE_APP_TYPEFORM_DELETION_FORM_ID

export const ENTRIES_PER_PAGE_KEY = "entriesPerPage"

export const DEFAULT_START_TIME = "09:00"
export const DEFAULT_END_TIME = "17:00"
export const DEFAULT_ROOM_BOOKING_TIME = 30

export const PERMISSIONS = {
  desks: {
    canAddDeskReservation: "desk.add_reservation",
    canDeleteDeskReservation: "desk.delete_reservation",
    canChangeDesk: "desk.change_deskresource",
    canEditDesk: ["desk.add_deskresource", "desk.delete_deskresource"],
    canChangeDeskTimeslot: "desk.change_timeslot",
    canChangeDeskCompanySettings: "desk.change_deskcompanysettings",
  },
  assets: {
    canAddAsset: "desk.add_assetresource",
    canDeleteAsset: "desk.delete_assetresource",
    canChangeAsset: "desk.change_assetresource",
    canChangeAssetType: "portal_resources.change_assettype",
  },
  amenities: {
    canChangeAmenity: "portal_resources.change_amenity",
  },
  buildings: {
    canAddBuilding: "portal_locations.add_building",
    canChangeBuilding: "portal_locations.change_building",
  },
  companies: {
    canChangeCompany: "portal_companies.change_company",
    canDeleteCompany: "portal_companies.delete_company",
  },
  floorPlans: {
    canAddFloor: "portal_locations.add_floor",
    canDeleteFloor: "portal_locations.delete_floor",
    canChangeFloor: "portal_locations.change_floor",
    canAddFloorPlan: "desk.add_floorplan",
    canDeleteFloorPlan: "desk.delete_floorplan",
  },
  departments: {
    canAddDepartment: "portal_locations.add_department",
    canChangeDepartment: "portal_locations.change_department",
    canOverrideDepartmentRules:
      "desk.view_reservation_override_department_rules",
  },
  documents: {
    canChangeVisitorDocument: "portal_visitors.change_visitorsdocuments",
    canChangeVisitorTabletSettings:
      "portal_visitors.change_visitorstabletsettings",
    canChangeVisitorPrinterSettings:
      "portal_visitors.change_visitorsprintersettings",
  },
  health: {
    canChangeHealth: "portal_screenings.change_screeningconfig",
  },
  users: {
    canChangeUser: "portal_users.change_user",
  },
  dashboard: {
    canChangeDashboardSettings: "dashboard.change_settings",
  },
  subscriptions: {
    canChangeSubscriptions: "portal_subscriptions.change_subscriptions",
  },
  accessTokens: {
    canChangeTokens: "oauth2_provider.change_accesstoken",
  },
}

export const ROLE_PERMISSIONS = {
  devicesManage: "devices_manage",
  peopleDirectoryManage: "people_directory_manage",
  rolesManage: "roles_manage",
  roomsAnalyticsView: "rooms_analytics_view",
  roomsAnalyticsExport: "rooms_analytics_export",
  desksAnalyticsView: "desks_analytics_view",
  desksAnalyticsExport: "desks_analytics_export",
  billingManage: "billing_manage",
  workspaceUse: "workspace_use",
  visitorsManage: "visitors_manage",
  visitorInvitesCreate: "visitor_invites_create",
  visitorInvitesManage: "visitor_invites_manage",
  visitorEntriesView: "visitor_entries_view",
  buildingsCreate: "buildings_create",
  buildingsManage: "buildings_manage",
  departmentsManage: "departments_manage",
  desksManage: "desks_manage",
  desksFloorPlansManage: "desks_floor_plans_manage",
  reservationsView: "reservations_view",
  reservationsManage: "reservations_manage",
  roomsManage: "rooms_manage",
  roomSettingsManage: "room_settings_manage",
  calendarSettingsManage: "calendar_settings_manage",
  organizationManage: "organization_manage",
  announcementsManage: "announcements_manage",
  healthManage: "health_manage",
  assetsManage: "assets_manage",
  employeesOnSiteView: "employees_on_site_view",
} as const

export type RolePermission =
  (typeof ROLE_PERMISSIONS)[keyof typeof ROLE_PERMISSIONS]

export const ROLE_PERMISSION_LABELS: Record<string, string> = {
  [ROLE_PERMISSIONS.devicesManage]: "general.permissions.roles.location_admin",
  [ROLE_PERMISSIONS.buildingsManage]:
    "general.permissions.roles.location_admin",
  [ROLE_PERMISSIONS.departmentsManage]:
    "general.permissions.roles.location_admin",
  [ROLE_PERMISSIONS.roomsManage]: "general.permissions.roles.location_admin",
  [ROLE_PERMISSIONS.assetsManage]: "general.permissions.roles.location_admin",
  [ROLE_PERMISSIONS.visitorsManage]:
    "general.permissions.roles.front_desk_admin",
  [ROLE_PERMISSIONS.desksManage]: "general.permissions.roles.front_desk_admin",
  [ROLE_PERMISSIONS.roomsAnalyticsView]:
    "general.permissions.roles.analytics_admin",
  [ROLE_PERMISSIONS.desksAnalyticsView]:
    "general.permissions.roles.analytics_admin",
  [ROLE_PERMISSIONS.peopleDirectoryManage]:
    "general.permissions.roles.security_admin",
  [ROLE_PERMISSIONS.billingManage]: "general.permissions.roles.billing_admin",
  [ROLE_PERMISSIONS.organizationManage]:
    "general.permissions.roles.global_admin",
  [ROLE_PERMISSIONS.announcementsManage]:
    "general.permissions.roles.global_admin",
  [ROLE_PERMISSIONS.healthManage]: "general.permissions.roles.global_admin",
  [ROLE_PERMISSIONS.workspaceUse]: "general.permissions.roles.user",
}

export const HTML_BLOCK_TAGS = [
  "p",
  "div",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "li",
  "ul",
  "ol",
] as const

export const APPS = {
  openPath: "open-path",
  web: "web",
  mobile: "mobile",
  visitor: "visitor",
  login: "login",
} as const

/**
 * Semver of the e-paper badge firmware bundled via `src/assets/firmware/` (`?url` import).
 * Must match the filename (e.g., "3.0.0" → APPFOTA3_0_0.bin).
 */
export const BUNDLED_EPAPER_BADGE_FIRMWARE_VERSION = "3.0.0" as const
